import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-description-locale-form-dialog",
  templateUrl: "./description-locale-form-dialog.component.html",
  styleUrls: ["./description-locale-form-dialog.component.scss"],
})
export class DescriptionLocaleFormDialogComponent implements OnInit {
  parentForm: FormGroup;
  formParam: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DescriptionLocaleFormDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.parentForm = this.data.parentForm;
      this.formParam = this.data.formParam;
    }
  }

  getFormControlName(localeControl) {
    return Object.keys(localeControl.controls)[0];
  }

  confirmDialog() {
    this.dialogRef.close(true);
  }
}
